export default __webpack_public_path__ + "static/hourglass-4600a749afd3fb75d359d74da5ea67c0.png";